<script lang="ts">import { page } from "$app/stores";
import { menuAutoCollapsed } from "../state";
import { Card } from "@infinitro/card";
import { providerBasePath, toSiteUrlWithActive } from "@infinitro/global";
export let game;
let isMenuCollapsed;
let hover = false;
let active = false;
let href = "";
[href, active] = toSiteUrlWithActive(`${providerBasePath(game.provider_slug)}${game.provider_slug}/${game.game_slug}`, $page.url.pathname);
$: {
	[href, active] = toSiteUrlWithActive(`${providerBasePath(game.provider_slug)}${game.provider_slug}/${game.game_slug}`, $page.url.pathname);
}
const link_over = (event) => {
	hover = true;
};
const link_out = (event) => {
	hover = false;
};
menuAutoCollapsed.subscribe((value) => {
	isMenuCollapsed = value;
});
</script>

<a {href} on:mouseenter={link_over} on:mouseleave={link_out}>
	<div class="item {active ? 'active' : ''} {isMenuCollapsed ? 'collapsed' : 'expanded'}">
		<div class="image-container">
			<Card item={game} thumbnail />
		</div>
		{#if !isMenuCollapsed}
			<p class="text {active ? 'active' : ''} {isMenuCollapsed ? 'collapsed' : ''}">
				{game.game}
			</p>
		{/if}
	</div>
</a>

<style>
	a {
		display:
			flex;
		border-radius:
			14px;
		font-size:
			1rem;
		line-height:
			1.5rem;
		--tw-text-opacity:
			1;
		color:
			rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family:
			var(--font-main)
}
	div.item {
		display:
			flex;
		max-height:
			48px;
		width:
			95%;
		cursor:
			pointer;
		align-items:
			center;
		gap:
			0.5rem;
		overflow:
			hidden;
		border-start-end-radius:
			0.25rem;
		border-end-end-radius:
			0.25rem;
		padding-top:
			0.25rem;
		padding-bottom:
			0.25rem;
		transition:
			width 0.1s ease,
			padding 0.1s ease,
			opacity 0.1s ease,
			justify-content 1s ease;
		transition-delay: 1s
}
	div.item.expanded {
		justify-content:
			flex-start
}
	div.item.collapsed {
		justify-content:
			center
}
	p.text {
		white-space:
			nowrap;
		font-size:
			12px;
		font-family:
			var(--font-main);
		transition:
			opacity 1s ease,
			width 1s ease
}
	p.text.collapsed {
		width:
			0px;
		opacity:
			0;
		transition:
			opacity 1s ease,
			width 1s ease
}
	p.active {
		--tw-text-opacity:
			1;
		color:
			rgb(255 255 255 / var(--tw-text-opacity, 1))
}
	.image-container {
		min-height:
			32px;
		width:
			auto;
		background-color:
			transparent;
		flex-shrink: 0
}
</style>
